"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("../..");

var _StepBarItem = _interopRequireDefault(require("../StepBarItem"));

var _StepBar = require("./StepBar.helper");

var S = _interopRequireWildcard(require("./StepBar.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var StepBar = function StepBar(_ref) {
  var step = _ref.step,
      defaultStep = _ref.defaultStep,
      steps = _ref.steps,
      onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, ["step", "defaultStep", "steps", "onChange"]);

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      stepIndex = _useState2[0],
      setStepIndex = _useState2[1];

  (0, _react.useEffect)(function () {
    return defaultStep ? setStepIndex((0, _StepBar.getIndex)(defaultStep)) : setStepIndex((0, _StepBar.getIndex)(step));
  }, [step, defaultStep]);

  var handleButtonClick = function handleButtonClick(index) {
    if (!step) {
      setStepIndex(index);
    }

    onChange({
      step: index + 1
    });
  };

  return /*#__PURE__*/_react["default"].createElement(S.StepBar, props, /*#__PURE__*/_react["default"].createElement(S.StepsList, null, steps.map(function (step, index) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: index
    }, /*#__PURE__*/_react["default"].createElement(_StepBarItem["default"], {
      buttonText: "".concat(index + 1),
      labelText: step,
      stepPosition: (0, _StepBar.getPosition)(index, stepIndex),
      onClick: function onClick() {
        return handleButtonClick(index);
      }
    }));
  })), /*#__PURE__*/_react["default"].createElement(S.Progress, null, /*#__PURE__*/_react["default"].createElement(_.Progress, {
    value: (0, _StepBar.getProgressAt)(stepIndex, steps.length)
  })));
};

StepBar.propTypes = {
  /**
   * The number of the current step for externally controlled
   * stepbars
   */
  step: _propTypes["default"].number,

  /**
   * The initial step to be displayed in internally cntrolled stepbars.
   */
  defaultStep: _propTypes["default"].number,

  /**
   * An array containing the titles of the steps in the display order.
   */
  steps: _propTypes["default"].arrayOf(_propTypes["default"].string),

  /**
   * Emits the value for the selected step when the user clicks
   * in any step button
   */
  onChange: _propTypes["default"].func
};
StepBar.defaultProps = {
  step: 0,
  defaultStep: 0,
  steps: [],
  onChange: function onChange() {}
};
var _default = StepBar;
exports["default"] = _default;